import { render } from "./EditCfpModal.vue?vue&type=template&id=6341a17c"
import script from "./EditCfpModal.vue?vue&type=script&lang=js"
export * from "./EditCfpModal.vue?vue&type=script&lang=js"
script.render = render

export default script